/**
 * @generated SignedSource<<61d562ee2601a5cf16c855048a9e9718>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DalAccountNav_accountNav$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"NavDropdownItem_navItem" | "NavItem_navItem">;
  readonly " $fragmentType": "DalAccountNav_accountNav";
}>;
export type DalAccountNav_accountNav$key = ReadonlyArray<{
  readonly " $data"?: DalAccountNav_accountNav$data;
  readonly " $fragmentSpreads": FragmentRefs<"DalAccountNav_accountNav">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DalAccountNav_accountNav",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_navItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavDropdownItem_navItem"
    }
  ],
  "type": "NavBarElement",
  "abstractKey": "__isNavBarElement"
};

(node as any).hash = "94a4fd3de960fc62836b9e1fee2d4047";

export default node;
